import gql from 'graphql-tag';

export const GET_MOST_RECENT_CUSTOM_ATTIRES = gql`
  query GetMostRecentCustomAttiresForClient($positionId: ID!) {
    getMostRecentCustomAttiresForClient(positionId: $positionId) {
      attires
    }
  }
`;
